// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__igRod","title":"Header_title__rw7Jn","side":"Header_side__3R7Gq"};